import React from 'react';

export class CallFnOnMount extends React.Component<{
    onMount: () => void;
    children?: React.ReactNode;
}> {
    componentDidMount() {
        this.props.onMount();
    }
    render() {
        return this.props.children;
    }
}
